
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view",
      function () {
        return require("private-next-pages/view/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view"])
      });
    }
  